import { ISearchPageParams } from '../Search/Types';

export enum IBroadcastActionTypes {
  GET_BROADCAST = '@@broadcast/GET_BROADCAST',
  GET_BROADCAST_SUCCESS = '@@broadcast/GET_BROADCAST_SUCCESS',
  GET_BROADCAST_FAILURE = '@@broadcast/GET_BROADCAST_FAILURE',

  GET_CSV = '@@broadcast/GET_CSV',
}

export interface IBroadcast {
  response: BroadcastResponse | null;
  isLoading: boolean;
  error: string;
  previousResponse: BroadcastResponse | null;
}

export interface BroadcastResponse {
  medias?: BroadcastMedia[];
  results: BroadcastResult[];
  total_count: number;
  total_pages: number;
}

export interface BroadcastMedia {
  count: number;
  id: number;
  name: string;
}

export interface BroadcastResult {
  end_date: string;
  id: number;
  media: Media;
  meta_broadcast: MetaBroadcast;
  no_diffusion?: boolean;
  metadatas: any;
  start_date: string;
}

export interface Media {
  id: number;
  name: string;
}

export interface MetaBroadcast {
  name: string;
  parent: string;
}

export interface BroadcastPayload {
  fgpid: number;
  bucketid: number;
  startdate: Date;
  enddate: Date;
  params: ISearchPageParams;
  media_ids?: Array<number>;
}
